module.exports = __webpack_public_path__ + "img/clarity-icon.a72f2fdd.svg";